import { Module } from 'vuex';
import {
  CosignerCreditScore,
  CreditScore,
  Degree,
  Submission,
  University,
  QuoteForm,
  RecommendationData,
} from '@/store/models';
import Vue from "vue";
import {getRecommendations} from "@/services/api";

interface SubmissionState {
  creditScore?: CreditScore;
  cosignerCreditScore?: CosignerCreditScore;
  university?: University;
  degree?: Degree;
  email?: String;
  submissions?: Array<Submission>;
  quotes?: Array<QuoteForm>;
  recommendationData?: RecommendationData;
}

const emptyQuote = () => ({
  lender: null,
  loanAmount: null,
  rateType: null,
  loanTerm: null,
  repaymentPlan: null,
  apr: null,
  sourcedViaLeverEdge: false,
  verified: false,
  borrowed: false,
  screenshot: null,
});

const submission: Module<SubmissionState, {}> = {
  state: {
    quotes: [emptyQuote()],
    submissions: [],
    recommendationData: {
      cosignerRecommendation: false,
      creditScoreRecommendation: false,
      lenderRecommendation: false,
      loanTermRecommendation: false,
      rateTypeRecommendation: false,
      repaymentPlanRecommendation: false,
    },
  },
  getters: {
    cosignerRecommendation(state) {
      return state.recommendationData?.cosignerRecommendation || false;
    },
    creditScoreRecommendation(state) {
      return state.recommendationData?.creditScoreRecommendation || false;
    },
    lenderRecommendation(state) {
      return state.recommendationData?.lenderRecommendation || false;
    },
    loanTermRecommendation(state) {
      return state.recommendationData?.loanTermRecommendation || false;
    },
    rateTypeRecommendation(state) {
      return state.recommendationData?.rateTypeRecommendation || false;
    },
    repaymentPlanRecommendation(state) {
      return state.recommendationData?.repaymentPlanRecommendation || false;
    },
  },
  namespaced: true,
  mutations: {
    setSubmissionFormField(state: SubmissionState, { field, value }) {
      Vue.set(state, field, value);
    },

    setSubmissions(state: SubmissionState, submissions: Array<Submission>) {
      state.submissions = submissions;
    },

    updateQuoteField(state: SubmissionState, { index, value, key }) {
      if(state.quotes){
        Vue.set(state.quotes[index], key, value);
      }
    },

    createQuote(state: SubmissionState) {
      if(state.quotes){
        state.quotes.push(emptyQuote());
      }
    },

    deleteQuote(state: SubmissionState, index) {
      if(state.quotes) {
        state.quotes.splice(index, 1);
      }
    },

    setRecommendationData(state: SubmissionState, data) {
      Vue.set(state, 'recommendationData', data);
    },

    resetState(state: SubmissionState) {
      state.creditScore = undefined;
      state.cosignerCreditScore = undefined;
      state.university = undefined;
      state.degree = undefined;
      state.email = undefined;
      state.quotes = [emptyQuote()];
    },
  },

  actions: {
    setFormField(store, { value, field }) {
      store.commit('setSubmissionFormField', { value, field });
    },

    setQuoteValue(store, { index, value, key }) {
      store.commit('updateQuoteField', { index, value, key });
    },

    setAllSubmissions(store, response) {
      store.commit('setSubmissions', response.data.data);
    },

    pushQuote(store) {
      store.commit('createQuote');
    },

    removeQuote(store, index) {
      store.commit('deleteQuote', index);
    },

    setRecommendationData(store, data) {
      store.commit('setRecommendationData', data);
    },

    resetState(store) {
      store.commit('resetState');
    },
  },
};

export default submission;
